import { useState, useEffect } from 'react'
import axios from 'axios'
import { Options, OptionsValue } from '../../control/materialUI/SplitBottonControl'
import useMapStore from '../../stores/useMapStore'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'
import { SortType, SignalStateIndexEnum } from '../../typings/Enum'
import useFormReportStore from '../../stores/useFormReportStore'
import { useSelector } from 'react-redux'
import { RootStateType } from '../../redux/reducer/rootReducer'
import * as am4core from '@amcharts/amcharts4/core'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { useHistory } from 'react-router-dom'

am4core.useTheme(am4themes_animated)

const options: Options[] = [
    {
        value: 'pdf',
        label: 'ดาวน์โหลดรายงาน (PDF)',
    },
    {
        value: 'excel',
        label: 'ดาวน์โหลดรายงาน (Excel)',
    },
]

const dataSort = [
    {
        value: 'asc',
        label: 'เก่าไปใหม่',
    },
    {
        value: 'desc',
        label: 'ใหม่ไปเก่า',
    },
]

const useReportFeedback = () => {
    const mapStore = useMapStore()
    const loadingStore = useLoadingStore()
    const formReportStore = useFormReportStore()
    const { loginProfile, isLoggedIn } = useSelector(({ profile }: RootStateType) => profile)

    const [layout, setLayout] = useState<boolean>(true)
    const [isIos, setIsIos] = useState<boolean>(false)
    const [year, setYear] = useState<number>(new Date().getFullYear() + 543)
    const [month, setMonth] = useState<number>(new Date().getMonth() + 1)
    const [sort, setSort] = useState<string>('asc')
    const [dataReport, setDataReport] = useState<Array<ReportItemDataType>>([])
    const [dataYear, setDataYear] = useState<Array<DropdownDataType>>([{ label: year.toString(), value: year }])
    const [dataMonth, setDataMonth] = useState<Array<DropdownDataType>>([{ label: month.toString(), value: month }])
    const [dashboard, setDashboard] = useState<ReportDashboardFeedbackResponseType>()
    const [barChartColor, setBarChartColor] = useState<string>('#F15F31')
    const [barChartTitle, setBarChartTitle] = useState<string>('')
    const [dataPie, setDataPie] = useState<Array<SignalStatePieChartType>>([])
    const [dataBarHorizontal, setDataBarHorizontal] = useState<Array<SignalStateBarChartType>>([])
    const [dataBarVertical, setDataBarVertical] = useState<Array<AntennaTypeBarChartType>>([])
    const [openDialogError, setOpenDialogError] = useState<boolean>(false)
    const history = useHistory()

    useEffect(() => {
        const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent)
        setIsIos(isIos)
    }, [])

    const onChangeYear = (evt: DropdownChangeEvent) => {
        setYear(evt as number)
        getReportData(evt as number, month)
    }

    const onChangeMonth = (evt: DropdownChangeEvent) => {
        setMonth(evt as number)
        getReportData(year, evt as number)
    }

    const getReportList = async (searchYear: number, searchMonth: number) => {
        try {
            let url = `${process.env.REACT_APP_API}/api/report/feedback/list?year=${searchYear.toString()}`
            if (searchMonth !== 0) {
                url = `${
                    process.env.REACT_APP_API
                }/api/report/feedback/list/?year=${searchYear.toString()}&month=${searchMonth.toString()}`
            }
            const result = await axios.get(url, ConfigAPI)
            let reportData: Array<ReportItemDataType> = []
            if (result.data) {
                reportData = result.data.map((item: ReportFeedbackResponseType) => {
                    let retItem: ReportItemDataType = {
                        dataId: item.feedbackId,
                        no: item.no,
                        name: item.administrative,
                        location: item.receivingPoint,
                        signalState: item.signalState,
                        createDate: item.createDate,
                    }
                    return retItem
                }) as Array<ReportItemDataType>
            }
            return reportData
        } catch (error) {
            formReportStore.setFeedbackDetail(null)
            formReportStore.setIsOpenFeedbackDetail(false)
            mapStore.clearReportDataResult()
        }
    }

    const getReportDashbaord = async (searchYear: number, searchMonth: number) => {
        try {
            let url = `${process.env.REACT_APP_API}/api/report/feedback/dashboard?year=${searchYear.toString()}`
            if (searchMonth !== 0) {
                url = `${
                    process.env.REACT_APP_API
                }/api/report/feedback/dashboard/?year=${searchYear.toString()}&month=${searchMonth.toString()}`
            }
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                const reportDashboardData: ReportDashboardFeedbackResponseType = {
                    // Mock data for test
                    // signalStateChart: result.data.signalStateChart.map((item: any) => {
                    //     if (item.xValue === 0) {
                    //         item.yValue = 6
                    //         item.provinces = [{name: 'สุรินทร์', xValue: 0, yValue: 6}]
                    //     }
                    //     if (item.xValue === 1) {
                    //         item.yValue = 0
                    //         // item.provinces = [{name: 'สุรินทร์', xValue: 0, yValue: 1}]
                    //     }
                    //     if (item.xValue === 2) {
                    //         item.yValue = 0
                    //         // item.provinces = [{name: 'สุรินทร์', xValue: 0, yValue: 6}]
                    //     }
                    //     return item
                    // }),
                    // End Mock data for test

                    signalStateChart: result.data.signalStateChart,
                    antennaTypeChart: result.data.antennaTypeChart,
                }

                setDashboard(reportDashboardData)
                return reportDashboardData
            }
        } catch (error) {}
    }

    const getReportData = async (searchYear: number, searchMonth: number) => {
        loadingStore.setLoading(true)
        Promise.all([getReportList(searchYear, searchMonth), getReportDashbaord(searchYear, searchMonth)])
            .then((res) => {
                // console.log('res', res)
                if (res[0] && res[0].length > 0) {
                    mapStore.drawReportDataResult(res[0], 'feedback')
                    setDataReport(res[0])
                } else {
                    mapStore.drawReportDataResult([], 'feedback')
                }

                if (res[1]) {
                    const signalStateChartData: SignalStateChartType[] = res[1].signalStateChart
                    const antennaTypeChartData: AntennaTypeChartType[] = res[1].antennaTypeChart

                    const signalStatePieChart: SignalStatePieChartType[] = []
                    signalStateChartData.forEach((item) => {
                        signalStatePieChart.push({
                            signal: item.name,
                            sum: item.yValue,
                            color: preparePieChartColor(item.xValue),
                        })
                    })
                    setDataPie(signalStatePieChart)

                    const signalStateMax = signalStateChartData.reduce((prev, current) => {
                        return prev.yValue > current.yValue ? prev : current
                    })
                    setBarChartTitle(signalStateMax?.name ?? '')

                    const signalStateBarChart = signalStateMax?.provinces
                        ?.map((item) => {
                            return {
                                provinces: item.name,
                                value: item.yValue,
                            }
                        })
                        .slice(0, 5)
                        .sort((a, b) => (a.value as number) - (b.value as number))
                    setDataBarHorizontal(signalStateBarChart ?? [])

                    const xValue = signalStateMax?.xValue
                    prepareBarChartColor(xValue)

                    const antennaTypeChart = antennaTypeChartData.map((item) => {
                        return {
                            antennaType: item.name,
                            value: item.yValue,
                        }
                    })
                    setDataBarVertical(antennaTypeChart)
                } else {
                    setDataReport([])
                }
            })
            .finally(() => loadingStore.setLoading(false))
    }

    const onClickOption = async (selectValue: OptionsValue) => {
        loadingStore.setLoading(true)
        const fullname = loginProfile.fullname
        let url = `${process.env.REACT_APP_API_REPORT}/feedback?year=${year}&createBy=${fullname}&fileType=${selectValue}`
        if (month !== 0) {
            url = `${process.env.REACT_APP_API_REPORT}/feedback?year=${year}&month=${month}&createBy=${fullname}&fileType=${selectValue}`
        }
        try {
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                globalThis.open(result.data.urlPath, '_blank')
            }
        } catch (ex) {
            console.log(ex)
            setOpenDialogError(true)
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const onMenuItemClick = (selectValue: OptionsValue) => {
        onClickOption(selectValue)
    }

    const onClickLayout = (name: typeof layout) => {
        setLayout(name)
    }

    const handleCloseErrorDialog = () => {
        setOpenDialogError(false)
    }

    const handleClickViewPosition = async (item: ReportItemDataType) => {
        try {
            loadingStore.setLoading(true)
            const data = await formReportStore.getFeedbackDetail(item.dataId as number)
            if (data) {
                formReportStore.setFeedbackDetail(data)
                if (item.location) {
                    mapStore.zoomLocationByLatLon(item.location, item.dataId, 12)
                }
                formReportStore.setIsOpenFeedbackDetail(true)
            } else {
                formReportStore.setFeedbackDetail(null)
                formReportStore.setIsOpenFeedbackDetail(false)
            }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const handleSortData = (evt: DropdownChangeEvent) => {
        setSort(evt as string)
    }

    const getDataSort = () => {
        switch (sort) {
            case SortType.Asc:
                return dataReport.slice().sort((a, b) => a.no - b.no)
            case SortType.Desc:
                return dataReport.slice().sort((a, b) => b.no - a.no)
            default:
                return []
        }
    }

    const handelClickChart = (properties?: string) => {
        if (dashboard) {
            const signalStateBarChart = dashboard.signalStateChart
                .filter((item) => item.name === properties)
                ?.flatMap((item) =>
                    item.provinces.map((itm) => {
                        return {
                            provinces: itm.name,
                            value: itm.yValue,
                        }
                    }),
                )
                .slice(0, 5)
                .sort((a, b) => (a.value as number) - (b.value as number))
            setDataBarHorizontal(signalStateBarChart)

            const xValue = dashboard.signalStateChart.find((item) => item.name === properties)?.xValue
            setBarChartTitle(properties ?? '')
            prepareBarChartColor(xValue)
        }
    }

    const preparePieChartColor = (xValue?: number) => {
        switch (xValue) {
            case SignalStateIndexEnum.None:
                return am4core.color('#F15F31')
            case SignalStateIndexEnum.Abnormal:
                return am4core.color('#F1BC31')
            case SignalStateIndexEnum.Normal:
                return am4core.color('#679A2E')
            default:
                return am4core.color('#F15F31')
        }
    }

    const prepareBarChartColor = (xValue?: number) => {
        switch (xValue) {
            case SignalStateIndexEnum.None:
                setBarChartColor('#F15F31')
                break
            case SignalStateIndexEnum.Abnormal:
                setBarChartColor('#F1BC31')
                break
            case SignalStateIndexEnum.Normal:
                setBarChartColor('#679A2E')
                break
            default:
                setBarChartColor('#F15F31')
                break
        }
    }

    useEffect(() => {
        let localRefId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)

        if (!localRefId) {
            localRefId = globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        }

        if (localRefId) {
            if (isLoggedIn) {
                callServiceLookup()
            }
        } else {
            globalThis.sessionStorage.clear()
            globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
            history.push('/')
        }
    }, [isLoggedIn])

    useEffect(() => {
        return () => {
            //When Unmount Component
            formReportStore.setFeedbackDetail(null)
            formReportStore.setIsOpenFeedbackDetail(false)
            formReportStore.setIsDisabledMapTool(false)
            mapStore.clearReportDataResult()
        }
    }, [])

    const callServiceLookup = async () => {
        try {
            formReportStore.setIsDisabledMapTool(true)
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/report/feedback/lookup`
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                setDataYear(() => {
                    return result.data.years.map((year: string) => {
                        return {
                            label: year,
                            value: parseInt(year),
                        }
                    })
                })

                setDataMonth(() => {
                    return result.data.months.map((month: ResponseLookupType) => {
                        return {
                            label: month.name,
                            value: month.code ? month.code : 0,
                        }
                    })
                })

                await getReportData(year, month)
            }
        } catch (error) {
            loadingStore.setLoading(false)
            history.push('/')
        }
    }

    return {
        drawer: {
            openDrawer: formReportStore.isOpenDrawerFeedback,
            openDrawerDetail: formReportStore.isOpenFeedbackDetail,
            layout,
            onClickLayout,
            setOpenDrawer: formReportStore.setIsOpenDrawerFeedback,
            setOpenDrawerDetail: formReportStore.setIsOpenFeedbackDetail,
            onClickViewPosition: handleClickViewPosition,
        },
        getDataSort,
        YM: {
            dataYear,
            dataMonth,
            year,
            month,
            onChangeYear,
            onChangeMonth,
        },
        options: {
            options,
            onClickOption,
            onMenuItemClick,
        },
        dataSort,
        sort,
        handleSortData,
        dataReportDetail: formReportStore.feedbackDetail,
        chartProp: {
            dataPie,
            dataBarHorizontal,
            dataBarVertical,
            barChartColor,
            barChartTitle,
            onClickChart: handelClickChart,
            dataBarVerticalSum: dataBarVertical.map((item) => item.value).reduce((a, b) => a + b, 0),
        },
        isIos,
        openDialogError,
        handleCloseErrorDialog,
    }
}

export default useReportFeedback
